if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.variantIdInput.disabled = false;
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this),
                );
                this.cart =
                    document.querySelector("cart-drawer") ||
                    document.querySelector("cart-notification");
                this.submitButton = this.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector("span");

                if (document.querySelector("cart-drawer"))
                    this.submitButton.setAttribute("aria-haspopup", "dialog");

                this.hideErrors = this.dataset.hideErrors === "true";
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true")
                    return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove(
                    "hidden",
                );

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";

                const formData = new FormData(this.form);
                const bundleRefPropertyKey = "properties[_bundle_ref]";
                const generatedBundleRef = this.generateBundleRef();
                const sourceProductHandle = this.getSourceProductHandle();
                if (sourceProductHandle) {
                    formData.set(
                        "properties[_source_product_handle]",
                        sourceProductHandle,
                    );
                }
                fetch(
                    "http://127.0.0.1:7349/ingest/1cc0ff24-142a-4d74-b824-f0f806dd2115",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Debug-Session-Id": "97d264",
                        },
                        body: JSON.stringify({
                            sessionId: "97d264",
                            runId: "baseline",
                            hypothesisId: "H1",
                            location:
                                "assets/product-form.js:onSubmitHandler:bundleRefGenerated",
                            message:
                                "Generated bundle reference and base form values",
                            data: {
                                variantId: String(formData.get("id") || ""),
                                quantity: String(
                                    formData.get("quantity") || "",
                                ),
                                bundleRef: String(generatedBundleRef || ""),
                                sourceProductHandle: String(
                                    sourceProductHandle || "",
                                ),
                            },
                            timestamp: Date.now(),
                        }),
                    },
                ).catch(() => {});
                // #endregion

                const protectionVariantId = formData.get(
                    "properties[_protection_variant_id]",
                );
                const protectionPropertyKey = Array.from(formData.keys()).find(
                    (key) => key.indexOf("properties[Extra protection") === 0,
                );
                const protectionEnabled = protectionPropertyKey
                    ? String(
                          formData.get(protectionPropertyKey),
                      ).toLowerCase() === "added"
                    : false;
                const extraItemVariantId = formData.get(
                    "properties[_extra_item_variant_id]",
                );
                const extraItemProtectionVariantId = formData.get(
                    "properties[_extra_item_protection_variant_id]",
                );
                const extraItemPropertyKey = Array.from(formData.keys()).find(
                    (key) =>
                        key.indexOf("properties[Extra item (cushion) - ") === 0,
                );
                const extraItemProtectionPropertyKey = Array.from(
                    formData.keys(),
                ).find(
                    (key) =>
                        key.indexOf(
                            "properties[Extra fabric protection  - ",
                        ) === 0,
                );
                const extraItemEnabled = extraItemPropertyKey
                    ? String(
                          formData.get(extraItemPropertyKey),
                      ).toLowerCase() === "added"
                    : false;
                const extraItemProtectionEnabled =
                    extraItemProtectionPropertyKey
                        ? String(
                              formData.get(extraItemProtectionPropertyKey),
                          ).toLowerCase() === "added"
                        : false;
                // #region agent log
                fetch(
                    "http://127.0.0.1:7349/ingest/1cc0ff24-142a-4d74-b824-f0f806dd2115",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Debug-Session-Id": "97d264",
                        },
                        body: JSON.stringify({
                            sessionId: "97d264",
                            runId: "baseline",
                            hypothesisId: "H2",
                            location:
                                "assets/product-form.js:onSubmitHandler:propertySnapshot",
                            message:
                                "Snapshot of add-to-cart properties and API mode",
                            data: {
                                shouldUseItemsApi: false,
                                protectionVariantId: String(
                                    protectionVariantId || "",
                                ),
                                protectionEnabled: Boolean(protectionEnabled),
                                extraItemVariantId: String(
                                    extraItemVariantId || "",
                                ),
                                extraItemEnabled: Boolean(extraItemEnabled),
                                extraItemProtectionVariantId: String(
                                    extraItemProtectionVariantId || "",
                                ),
                                extraItemProtectionEnabled: Boolean(
                                    extraItemProtectionEnabled,
                                ),
                                formProperties: Object.fromEntries(
                                    Array.from(formData.entries())
                                        .filter(
                                            ([key]) =>
                                                key.indexOf("properties[") ===
                                                0,
                                        )
                                        .map(([key, value]) => [
                                            key,
                                            String(value),
                                        ]),
                                ),
                            },
                            timestamp: Date.now(),
                        }),
                    },
                ).catch(() => {});
                // #endregion

                if (this.cart) {
                    formData.append(
                        "sections",
                        this.cart
                            .getSectionsToRender()
                            .map((section) => section.id),
                    );
                    formData.append("sections_url", window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }

                formData.delete(bundleRefPropertyKey);
                delete config.headers["Content-Type"];
                config.body = formData;

                Promise.resolve()
                    .then(() =>
                        this.validateOnePerCustomerLimit(formData.get("id")),
                    )
                    .then(() =>
                        fetch(
                            `${window.routes?.cart_add_url ?? "/cart/add"}`,
                            config,
                        ),
                    )
                    .then((response) => response.json())
                    .then((response) => {
                        // #region agent log
                        fetch(
                            "http://127.0.0.1:7349/ingest/1cc0ff24-142a-4d74-b824-f0f806dd2115",
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Debug-Session-Id": "97d264",
                                },
                                body: JSON.stringify({
                                    sessionId: "97d264",
                                    runId: "baseline",
                                    hypothesisId: "H3",
                                    location:
                                        "assets/product-form.js:onSubmitHandler:cartAddResponse",
                                    message:
                                        "cart/add response payload metadata",
                                    data: {
                                        status: response?.status ?? null,
                                        key: String(response?.key || ""),
                                        id: String(response?.id || ""),
                                        variantId: String(
                                            response?.variant_id || "",
                                        ),
                                        quantity: response?.quantity ?? null,
                                        properties:
                                            response?.properties || null,
                                        hasItems: Array.isArray(
                                            response?.items,
                                        ),
                                        itemCount: Array.isArray(
                                            response?.items,
                                        )
                                            ? response.items.length
                                            : null,
                                    },
                                    timestamp: Date.now(),
                                }),
                            },
                        ).catch(() => {});
                        // #endregion
                        console.log(
                            "[ATC Debug] cart/add response key:",
                            response?.key,
                            "source handle:",
                            sourceProductHandle || "(empty)",
                        );
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage =
                                this.submitButton.querySelector(
                                    ".sold-out-message",
                                );
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute(
                                "aria-disabled",
                                true,
                            );
                            this.submitButtonText.classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes?.cart_url || '/cart';
                            return;
                        }

                        const startMarker =
                            CartPerformance.createStartingMarker(
                                "add:wait-for-subscribers",
                            );
                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: "product-form",
                                productVariantId: formData.get("id"),
                                cartData: response,
                            }).then(() => {
                                CartPerformance.measureFromMarker(
                                    "add:wait-for-subscribers",
                                    startMarker,
                                );
                            });
                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        CartPerformance.measure(
                                            "add:paint-updated-sections",
                                            () => {
                                                this.cart.renderContents(
                                                    response,
                                                );
                                            },
                                        );
                                    });
                                },
                                { once: true },
                            );
                            quickAddModal.hide(true);
                        } else {
                            CartPerformance.measure(
                                "add:paint-updated-sections",
                                () => {
                                    this.cart.renderContents(response);
                                },
                            );
                        }
                        // #region agent log
                        fetch(
                            "http://127.0.0.1:7349/ingest/1cc0ff24-142a-4d74-b824-f0f806dd2115",
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Debug-Session-Id": "97d264",
                                },
                                body: JSON.stringify({
                                    sessionId: "97d264",
                                    runId: "baseline",
                                    hypothesisId: "H4",
                                    location:
                                        "assets/product-form.js:onSubmitHandler:renderCartContents",
                                    message:
                                        "Rendering cart with response sections",
                                    data: {
                                        hasCart: Boolean(this.cart),
                                        sections: response?.sections
                                            ? Object.keys(response.sections)
                                            : [],
                                        sectionCount: response?.sections
                                            ? Object.keys(response.sections)
                                                  .length
                                            : 0,
                                    },
                                    timestamp: Date.now(),
                                }),
                            },
                        ).catch(() => {});
                        // #endregion
                    })
                    .catch((e) => {
                        if (e?.message === "ONE_PER_CUSTOMER_LIMIT_REACHED")
                            return;
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (
                            this.cart &&
                            this.cart.classList.contains("is-empty")
                        )
                            this.cart.classList.remove("is-empty");
                        if (!this.error)
                            this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading__spinner").classList.add(
                            "hidden",
                        );

                        CartPerformance.measureFromEvent(
                            "add:user-action",
                            evt,
                        );
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper ||
                    this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage ||
                    this.errorMessageWrapper.querySelector(
                        ".product-form__error-message",
                    );

                this.errorMessageWrapper.toggleAttribute(
                    "hidden",
                    !errorMessage,
                );

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }

            validateOnePerCustomerLimit(variantId) {
                if (this.dataset.onePerCustomer !== "true") {
                    return Promise.resolve();
                }

                const numericVariantId = Number(variantId);
                if (!Number.isFinite(numericVariantId)) {
                    return Promise.resolve();
                }

                const cartJsonUrl = `${window.routes?.cart_url || "/cart"}.js`;
                return fetch(cartJsonUrl)
                    .then((response) => response.json())
                    .then((cartData) => {
                        const alreadyInCart = Array.isArray(cartData?.items)
                            ? cartData.items.some(
                                  (item) => Number(item?.variant_id) === numericVariantId,
                              )
                            : false;
                        if (!alreadyInCart) return;

                        const limitMessage =
                            window.variantStrings?.onePerCustomerLimit ||
                            "Limit: 1 per customer";
                        this.handleErrorMessage(limitMessage);
                        throw new Error("ONE_PER_CUSTOMER_LIMIT_REACHED");
                    })
                    .catch((error) => {
                        if (error?.message === "ONE_PER_CUSTOMER_LIMIT_REACHED") {
                            throw error;
                        }
                    });
            }

            toggleSubmitButton(disable = true, text) {
                if (this.dataset.onePerCustomer === "true") {
                    const customerLoggedIn = this.dataset.customerLoggedIn === "true";
                    const customerHasTag = this.dataset.customerHasTag === "true";
                    
                    if (!customerLoggedIn) {
                        return; // Keep as login link/button, don't let JS touch it.
                    } else if (customerHasTag) {
                        this.submitButton.setAttribute("disabled", "disabled");
                        if (this.submitButtonText) {
                            this.submitButtonText.textContent = window.variantStrings?.onePerCustomerLimit || "Limit: 1 per customer";
                        }
                        return;
                    }
                }

                if (disable) {
                    this.submitButton.setAttribute("disabled", "disabled");
                    if (text && this.submitButtonText) this.submitButtonText.textContent = text;
                } else {
                    this.submitButton.removeAttribute("disabled");
                    if (this.submitButtonText) {
                        this.submitButtonText.textContent =
                            window.variantStrings?.addToCart || 'Add to cart';
                    }
                }
            }

            extractProperties(formData) {
                const properties = {};
                formData.forEach((value, key) => {
                    const match = key.match(/^properties\[(.*)\]$/);
                    if (!match) return;
                    const propertyKey = match[1];
                    properties[propertyKey] = value;
                });
                return properties;
            }

            generateBundleRef() {
                if (window.crypto && window.crypto.randomUUID) {
                    return `bundle-${window.crypto.randomUUID()}`;
                }
                return `bundle-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            }

            buildStableBundleRef({
                parentVariantId,
                protectionVariantId,
                extraItemVariantId,
                extraItemProtectionVariantId,
            }) {
                const toToken = (value) =>
                    String(value || "0").replace(/[^a-zA-Z0-9_-]/g, "");
                return `bundle-${toToken(parentVariantId)}-p${toToken(protectionVariantId)}-e${toToken(extraItemVariantId)}-ep${toToken(extraItemProtectionVariantId)}`;
            }

            getSourceProductHandle() {
                const productInfo = this.closest("product-info");
                const urlFromData = productInfo?.dataset?.url;
                if (urlFromData && urlFromData.includes("/products/")) {
                    const cleaned = urlFromData
                        .split("?")[0]
                        .replace(/\/+$/, "");
                    return cleaned.split("/").pop();
                }

                const formAction = this.form?.getAttribute("action");
                if (formAction && formAction.includes("/products/")) {
                    const cleaned = formAction
                        .split("?")[0]
                        .replace(/\/+$/, "");
                    return cleaned.split("/").pop();
                }

                const currentPath = window.location.pathname;
                if (currentPath && currentPath.includes("/products/")) {
                    const cleaned = currentPath
                        .split("?")[0]
                        .replace(/\/+$/, "");
                    return cleaned.split("/").pop();
                }

                return "";
            }

            get variantIdInput() {
                return this.form.querySelector("[name=id]");
            }
        },
    );
}
